export const WITHDRAWAL_WINDOW_DAYS = 14;
export var WithdrawalContractType;
(function (WithdrawalContractType) {
    WithdrawalContractType["MYGATE_PLATFORM"] = "mygate_platform";
    WithdrawalContractType["PAYCENTER"] = "paycenter";
})(WithdrawalContractType || (WithdrawalContractType = {}));
export var WithdrawalStatus;
(function (WithdrawalStatus) {
    WithdrawalStatus["DECLARED"] = "DECLARED";
    WithdrawalStatus["RECEIPT_SENT"] = "RECEIPT_SENT";
    WithdrawalStatus["ACKNOWLEDGED"] = "ACKNOWLEDGED";
    WithdrawalStatus["PROCESSED"] = "PROCESSED";
})(WithdrawalStatus || (WithdrawalStatus = {}));
//# sourceMappingURL=withdrawal.types.js.map